
{
  "labels": {
    "global-nav": "Changes to the navigation affect all pages."
  }
}
